import { Link } from "react-router-dom";

const COLOR = { ink: "var(--pr-ink)", ink2: "var(--pr-ink2)", muted: "var(--pr-muted)", line: "var(--pr-line)" };

// Warm words read as "on pace", cool words as "strain", purely a visual cue, never a judgment.
const TONE = {
  smooth: "var(--pr-tint-green)", steady: "var(--pr-tint-green)", "too easy": "var(--pr-tint-green)",
  surprising: "var(--pr-tint-gold)", uneven: "var(--pr-tint-gold)", tight: "var(--pr-tint-gold)",
  crunchy: "var(--pr-tint-red)", chaotic: "var(--pr-tint-red)", heavy: "var(--pr-tint-red)", "off track": "var(--pr-tint-red)",
};

const splitFeel = (feel) => String(feel || "").split(",").map((w) => w.trim()).filter(Boolean);

/** How each quarter felt, the racer's own words, in order, so the year's rhythm is visible at a glance. */
export const FeelTrends = ({ resets }) => {
  const rows = [...(resets || [])].sort((a, b) => String(a.quarter).localeCompare(String(b.quarter)));
  if (rows.length === 0) return null;
  const tally = {};
  rows.forEach((r) => splitFeel(r.feel).forEach((w) => { tally[w] = (tally[w] || 0) + 1; }));
  const top = Object.entries(tally).sort((a, b) => b[1] - a[1]).slice(0, 3);

  return (
    <section className="rounded-2xl p-5 lg:p-6 pr-card mb-6" data-testid="scoreboard-feel-trends">
      <div className="flex items-baseline justify-between gap-3 flex-wrap mb-3">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest" style={{ color: COLOR.muted }}>Pit Stop check-ins</p>
          <h2 className="text-lg font-bold" style={{ color: COLOR.ink }}>How each quarter felt</h2>
        </div>
        <Link to="/app/reset" className="text-xs font-semibold underline" style={{ color: COLOR.ink2 }} data-testid="feel-trends-reset-link">Open Pit Stop →</Link>
      </div>
      <ol className="space-y-2.5">
        {rows.map((r) => {
          const words = splitFeel(r.feel);
          const q = String(r.quarter).split("-").pop();
          return (
            <li key={r.quarter} className="flex items-start gap-3" data-testid={`feel-trend-${String(r.quarter).toLowerCase()}`}>
              <span className="w-9 shrink-0 text-xs font-bold pt-1" style={{ color: COLOR.ink }}>{q}</span>
              <div className="flex flex-wrap gap-1.5">
                {words.length === 0 && <span className="text-xs" style={{ color: COLOR.muted }}>, </span>}
                {words.map((w) => (
                  <span key={w} className="text-[11px] font-semibold px-2.5 py-1 rounded-full" style={{ background: TONE[w.toLowerCase()] || "var(--pr-tint-ink)", color: COLOR.ink }}>{w}</span>
                ))}
                {r.focus && <span className="text-[11px] font-semibold px-2 py-1" style={{ color: COLOR.ink2 }}>focus: {r.focus}</span>}
              </div>
            </li>
          );
        })}
      </ol>
      {top.length > 0 && rows.length > 1 && (
        <p className="text-xs mt-4 pt-3" style={{ color: COLOR.ink2, borderTop: `1px solid ${COLOR.line}` }} data-testid="feel-trends-summary">
          Most-used words this race: {top.map(([w, n]) => `${w} (${n})`).join(" · ")}
        </p>
      )}
    </section>
  );
};
